import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserData } from '../../providers/user-data';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ToastController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { OrganisationData } from '../../providers/organisation-data';
import { Storage } from '@ionic/storage';
import { GlobalVariable } from '../../global'
import { HomePage } from '../home/home';

@IonicPage()
@Component({
  selector: 'page-user-admin-form',
  templateUrl: 'user-form.html',
})
export class UserFormPage {
  userForm: FormGroup
  organisations: any
  organisationId: any;
  usertype: any
  constructor(public navCtrl: NavController, public navParams: NavParams, private userData: UserData, private formBuilder: FormBuilder,
    private toastCtrl: ToastController, private alertCtrl: AlertController, private organisationData: OrganisationData, private storage: Storage) {
    this.storage.get('organisationId').then((value) => {
      this.organisationId = value;

    });
    this.storage.get('usertype').then((value) => {
      this.usertype = value;
      console.log(!(this.usertype == GlobalVariable.Admin || this.usertype == GlobalVariable.Superadmin))
      if (!(this.usertype == GlobalVariable.Admin || this.usertype == GlobalVariable.Superadmin)) {
        this.navCtrl.setRoot(HomePage);
      }
    });
    this.userForm = this.formBuilder.group({
      organisationid: [''],
      usertype: ['', Validators.required],
      title: ['', Validators.required],
      surname: ['', Validators.required],
      forename: ['', Validators.required],
      logonid: ['', [Validators.required, Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$|^[a-zA-Z0-9]+$/)]],
      emailaddress: ['', [Validators.required, Validators.email]],
      contactnumber: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      password: [this.generatePassword(), [Validators.required, Validators.minLength(8), Validators.maxLength(20)]],
    });
  }

  ionViewCanEnter() {
    // return this.userData.authenticated();

  }

  ionViewDidLoad() {
    this.getOrganisaiton()
  }

  saveUser(value) {
    if (this.usertype == GlobalVariable.Admin) {
      this.userForm.controls['organisationid'].setValue(this.organisationId)
    }
    if (!this.userForm.controls['organisationid'].value) {
      this.presentAlert('Error', 'Please select organisation')
      return
    }
    this.userData.saveUser(this.userForm.value).subscribe(
      res => {
        if (res['success']) {
          this.presentToast(res['message'])
          this.userForm.reset()
        }
      },
      err => {
        if (err.error.data.logonid) {
          this.presentAlert('Error', err.error.data.logonid.msg)
        } else {
          this.presentAlert('Error', 'something went wrong, try again')
        }
      }
    )
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

  getOrganisaiton() {
    this.organisationData.getOrganisation().subscribe(
      res => {
        this.organisations = res['data']
      }
    )
  }

  generatePassword() {
    var length = 8,
      charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-form/user-form.ts